import Comment from 'components/taskDetail/Comment';
import TaskDetailTop from 'components/taskDetail/TaskDetailTop';
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan';

const TaskDetail = () => {

  return (
    <AnimatedSpan className='page-container d-flex flex-column'>
      <TaskDetailTop />
      <Comment />
    </AnimatedSpan>
  )
}

export default TaskDetail